<ng-content select="[legend]"></ng-content>
<ng-content></ng-content>